import * as React from 'react';
import { Dispatch, connect } from 'react-redux';
import { IApplicationState, AppActionCreators, ITicketingState, TicketingActionCreators, ICenterState, IAppState, ITicketLookupDataResponse, ContactActionCreators, ITicketResponse, ICannedResponseListResponse } from '@nkr/store/index';
import { ISelectItem, IContactListResponse, ITicketRequest } from '@nkr/models/index';
import { TicketStatus, TicketEntityType, TicketType, CannedResponseAvailability } from '@nkr/enums/index';
import { Button, FormGroup, ControlLabel, FormControl, Checkbox, Col, Alert, Glyphicon } from 'react-bootstrap';
import JoditEditor from '@nkr/components/editor';
import config from '../../jodit-editor-config';
import AsyncSelect from 'react-select/async';
import AsyncCreatable from 'react-select/async-creatable';
import CreatableSelect from 'react-select/creatable';
import { DropdownIndicator } from '../../dropdown-indicator';
import MyUploader from '../../file-upload';
import { toast } from 'react-toastify';
import { LinkButtonWrapper } from '../../styles';
import { INewContactValidation } from './new-contact-validation';
import NewContact from './new-contact';
import { debounce } from 'lodash';
import { OptionsType } from 'react-select';
import Drawer from 'rc-drawer';
import CannedResponses from '../../canned-responses';

interface IProps {
    centerId?: number
}

interface IStateProps {
    app: IAppState,
    ticketing: ITicketingState,
    centers: ICenterState
}

interface IDispatchProps {
    showLoading: (message: string) => Promise<void>,
    hideLoading: () => void,
    getLookupData: () => Promise<ITicketLookupDataResponse>,
    getContacts: (search: string) => Promise<IContactListResponse>,
    getCannedResponses: () => Promise<ICannedResponseListResponse>
    saveTicket: (newTicket: ITicketRequest) => Promise<ITicketResponse>
}

type TProps = IProps & IStateProps & IDispatchProps;

interface IValidation {
    contact: boolean,
    createNew: INewContactValidation,
    subject: boolean,
    status: boolean,
    urgency: boolean,
    description: boolean
}

interface IState {
    contact: ISelectItem,
    createNew: {
        show: boolean,
        firstName: string,
        lastName: string,
        email: string,
        phoneNumber: string
    },
    showCc: boolean,
    cc: ISelectItem[],
    subject: string,
    status: number,
    center: number,
    tier: number,
    urgency: number,
    ticketType: number,
    group: number,
    assignedTo: number,
    description: string,
    files: File[],
    tags: ISelectItem[],
    validation: IValidation,
    dirty: boolean,
    createAnother: boolean,
    showCannedResponses: boolean
}

const initialState: IState = {
    contact: null, //{ label: 'Kevin Nelson (knelson@kidneyregistry.org)', value: '4170' },
    createNew: {
        show: false,
        firstName: '',
        lastName: '',
        email: '',
        phoneNumber: ''
    },
    showCc: false,
    cc: [],
    subject: 'test',
    status: TicketStatus.Open,
    center: 0,
    tier: 0,
    urgency: -1,
    ticketType: -1,
    group: 0,
    assignedTo: 0,
    description: '',
    files: [],
    tags: [{ value: 'help', label: 'help' }],
    validation: {
        contact: true,
        createNew: {
            firstName: true,
            lastName: true,
            email: true,
            phoneNumber: true
        },
        subject: true,
        status: true,
        urgency: true,
        description: true
    },
    dirty: false,
    createAnother: false,
    showCannedResponses: false
}

class NewTicket extends React.Component<TProps, IState> {
    readonly state = initialState;

    private container: HTMLDivElement;

    componentDidMount = () => {
        this.getData();
    }

    handleContactChange = (list: ISelectItem) => {
        let validation = { ...this.state.validation };

        if (this.state.dirty)
            validation.contact = list != null;

        this.setState({
            contact: list,
            validation
        });
    }

    handleCreateNew = () => {
        this.setState({
            createNew: { ...this.state.createNew, show: true }
        });
    }

    handleNewContactDataChange = (value: string, property: string) => {
        this.setState({
            createNew: { ...this.state.createNew, [property]: value }
        });
    }

    handleCancelCreateNew = () => {
        this.setState({
            createNew: { ...this.state.createNew, show: false }
        });
    }

    handleShowCc = () => {
        this.setState({
            showCc: !this.state.showCc
        });
    }

    handleCcChange = (list: ISelectItem[]) => {
        list = list.map(item => {
            if (item.email == undefined)
                item.email = item.value;

            return item;
        });

        this.setState({
            cc: list
        });
    }

    handleSubjectChange = (e: React.FormEvent<FormControl & HTMLInputElement>) => {
        let validation = { ...this.state.validation };

        if (this.state.dirty)
            validation.subject = e.currentTarget.value != '';

        this.setState({
            subject: e.currentTarget.value,
            validation
        });
    }

    handleDropDownChange = (e: React.FormEvent<FormControl & HTMLSelectElement>) => {
        let state = { ...this.state };
        let id = e.currentTarget.id;

        state[id] = e.currentTarget.value;

        if (this.state.dirty && id == 'status')
            state.validation = { ...this.state.validation, status: e.currentTarget.value != '0' };

        this.setState(state);
    }

    handleDescriptionChange = (description: string) => {
        let validation = { ...this.state.validation };

        if (this.state.dirty)
            validation.description = description != '';

        this.setState({
            description,
            validation
        });
    }

    handleTagsChange = (list: ISelectItem[]) => {
        this.setState({
            tags: list
        });
    }

    handleFilesChanged = (file: File, status: string) => {
        let files = [...this.state.files];

        if (status == 'done') {
            files.push(file);
        }

        if (status == 'removed') {
            files = files.filter(x => x.name == file.name);
        }

        this.setState({
            files
        });
    }

    handleCreateAnotherChange = (e: React.FormEvent<Checkbox & HTMLInputElement>) => {
        this.setState({
            createAnother: e.currentTarget.checked
        });
    }

    handleSave = () => {
        this.saveTicket();
    }

    handleCancel = () => {
        window.location.href = '/ticketing/tickets';
    }

    handleShowCannedResponses = () => {
        this.setState({
            showCannedResponses: true
        });
    }

    handleCloseCannedResponses = () => {
        this.setState({
            showCannedResponses: false
        });
    }

    handleApplyCannedResponse = (id: number) => {
        let selectedCannedResponse = this.props.ticketing.cannedResponses.find(x => x.id == id);

        this.setState({
            showCannedResponses: false,
            description: selectedCannedResponse.message
        });
    }

    public saveContainer = (container: HTMLDivElement) => {
        this.container = container;
    };

    public getContainer = () => {
        return this.container;
    };

    getData = () => {
        this.props.showLoading('Getting things ready, one moment please...').then(() => {
            return Promise.all([
                this.props.getLookupData(),
                this.props.getCannedResponses()
            ]).then(() => {
                this.props.hideLoading();
            });
        });
    }

    loadContactOptions = debounce((search: string, callback: ((options: OptionsType<any>) => void)) => {
        if (search.length >= 3) {
            this.props.getContacts(search)
                .then(response => {
                    if (response.data.success) {
                        let results = response.data.results.map(x => { return { value: x.id, label: `${x.fullName} (${x.email})`, email: x.email }; });
                        callback(results);
                    }
                })
                .catch((error) => {
                    callback(error);
                });
        } else {
            callback([]);
        }
    }, 500)

    private validate = () => {
        let { contact, createNew, subject, status, urgency, description } = this.state;
        let { show, firstName, lastName, email, phoneNumber } = createNew;

        let validation: IValidation = {
            contact: createNew.show ? true : contact != null,
            createNew: {
                firstName: show ? firstName != '' : true,
                lastName: show ? lastName != '' : true,
                email: show ? email != '' : true,
                phoneNumber: show ? phoneNumber != '' : true
            },
            subject: subject != '',
            status: status > 0,
            urgency: urgency >= 0,
            description: description != ''
        };

        let isCreateNewValid = show ? firstName && lastName && email : true;
        let isValid = validation.contact && isCreateNewValid && validation.subject && validation.status && validation.urgency && validation.description;

        return { validation, isValid };
    }

    private saveTicket = () => {
        let validationResults = this.validate();

        this.setState({
            validation: validationResults.validation,
            dirty: true
        }, () => {
            if (validationResults.isValid) {
                let { contact, createNew, cc, subject, description, group, assignedTo, status, ticketType, tier, urgency, tags, files, center } = this.state;

                var newTicket: ITicketRequest = {
                    id: 0,
                    fromEmail: '',
                    contactId: contact != null ? parseInt(contact.value) : null,
                    cc: cc.map(x => x.email),
                    subject,
                    description,
                    firstName: createNew.show ? createNew.firstName : '',
                    lastName: createNew.show ? createNew.lastName : '',
                    email: createNew.show ? createNew.email : '',
                    phoneNumber: createNew.show ? createNew.phoneNumber : '',
                    groupId: group,
                    assignedUserId: assignedTo,
                    entityType: center > 0 ? TicketEntityType.Center : null,
                    entityTypeId: center > 0 ? center : null,
                    ticketStatusId: status,
                    ticketTypeId: ticketType,
                    tierLevelId: tier,
                    urgency,
                    isEmail: false,
                    tags: tags.map(x => x.label),
                    files
                };

                this.props.showLoading('Saving ticket, one moment please...').then(() => {
                    this.props.saveTicket(newTicket).then(response => {
                        this.props.hideLoading();

                        if (response.data.success) {
                            if (this.state.createAnother) {
                                toast.success('Ticket saved successfully');
                                this.setState(initialState);
                            } else {
                                toast.success('Ticket saved successfully', {
                                    onClose: () => {
                                        window.location.href = '/ticketing/tickets';
                                    }
                                });
                            }
                        }
                    });
                });
            } else {
                window.scrollTo(0, 0);
            }
        });
    }

    render = () => {
        const tagSuggestions = [];
        const validationResults = this.validate();

        const centerList = this.state.ticketType == TicketType.MemberCenterRequest ?
            this.props.ticketing.lookupData.centerList.filter(x => x.isMemberCenter)
            :
            this.props.ticketing.lookupData.centerList.filter(x => x.isMemberCenter == false);

        const cannedResponses = this.props.ticketing.cannedResponses.filter(x => {
            return x.availability == CannedResponseAvailability.AllAgents || (x.availability == CannedResponseAvailability.Myself && x.ownerId == this.props.app.user.id);
        });

        return (
            <>
                <div ref={this.saveContainer} />
                <div className='container' style={{ marginBottom: 20 }}>

                    {this.state.dirty && !validationResults.isValid && (
                        <div className='row'>
                            <Col xs={12} lg={12}>
                                <Alert bsStyle='danger'>
                                    The following issues were found:
                                    <ul>
                                        {!validationResults.validation.contact && (
                                            <li>Contact is required</li>
                                        )}

                                        {!validationResults.validation.createNew.firstName && (
                                            <li>First name is required</li>
                                        )}

                                        {!validationResults.validation.createNew.lastName && (
                                            <li>Last name is required</li>
                                        )}

                                        {!validationResults.validation.createNew.email && (
                                            <li>Email is required</li>
                                        )}

                                        {!validationResults.validation.createNew.phoneNumber && (
                                            <li>Phone number is required</li>
                                        )}

                                        {!validationResults.validation.subject && (
                                            <li>Subject is required</li>
                                        )}

                                        {!validationResults.validation.status && (
                                            <li>Status is required</li>
                                        )}

                                        {!validationResults.validation.urgency && (
                                            <li>Urgency is required</li>
                                        )}

                                        {!validationResults.validation.description && (
                                            <li>Description is required</li>
                                        )}
                                    </ul>
                                </Alert>
                            </Col>
                        </div>
                    )}

                    <div className='row'>
                        <div className='col-xs-12 col-lg-12'>
                            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                                <div>
                                    <h1 style={{ marginBottom: 30 }}>New Ticket</h1>
                                </div>
                                <div>
                                    <a className='btn btn-link' href='/ticketing/tickets'>Return to List</a>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className='row'>
                        <div className='col-xs-12 col-lg-12'>
                            {!this.state.createNew.show ?
                                <FormGroup style={{ marginBottom: 0 }} validationState={!this.state.validation.contact ? 'error' : null}>
                                    <ControlLabel>Select Contact</ControlLabel>
                                    <AsyncSelect
                                        value={this.state.contact}
                                        loadOptions={this.loadContactOptions}
                                        components={{ DropdownIndicator }}
                                        styles={{
                                            indicatorSeparator: defaultStyles => ({ ...defaultStyles }),
                                            dropdownIndicator: defaultStyles => ({
                                                ...defaultStyles,
                                                color: 'black'
                                            }),
                                            menu: defaultStyles => ({
                                                ...defaultStyles,
                                                zIndex: 99999
                                            }),
                                        }}
                                        isClearable={true}
                                        onChange={this.handleContactChange}
                                    />
                                    <div className='text-right'>
                                        <LinkButtonWrapper bsStyle='link' onClick={this.handleCreateNew}>Add New Contact</LinkButtonWrapper>

                                        {!this.state.showCc && (
                                            <>
                                                &nbsp;|&nbsp;
                                                <LinkButtonWrapper bsStyle='link' onClick={this.handleShowCc}>Add Cc</LinkButtonWrapper>
                                            </>
                                        )}
                                    </div>
                                </FormGroup>
                                :
                                <NewContact
                                    data={this.state.createNew}
                                    validation={this.state.validation.createNew}
                                    onDataChange={this.handleNewContactDataChange}
                                    onCancel={this.handleCancelCreateNew}
                                />
                            }

                            {this.state.showCc && (
                                <FormGroup style={{ marginBottom: 0 }}>
                                    <ControlLabel>Cc</ControlLabel>
                                    <AsyncCreatable
                                        value={this.state.cc}
                                        loadOptions={this.loadContactOptions}
                                        components={{ DropdownIndicator }}
                                        styles={{
                                            indicatorSeparator: defaultStyles => ({ ...defaultStyles }),
                                            dropdownIndicator: defaultStyles => ({
                                                ...defaultStyles,
                                                color: 'black'
                                            }),
                                            menu: defaultStyles => ({
                                                ...defaultStyles,
                                                zIndex: 99999
                                            }),
                                        }}
                                        isClearable={true}
                                        isMulti={true}
                                        onChange={this.handleCcChange}
                                    />
                                    <div className='text-right'>
                                        <LinkButtonWrapper bsStyle='link' onClick={this.handleShowCc}>Hide Cc</LinkButtonWrapper>
                                    </div>
                                </FormGroup>
                            )}

                            <FormGroup validationState={!this.state.validation.subject ? 'error' : null}>
                                <ControlLabel>Subject</ControlLabel>
                                <FormControl
                                    value={this.state.subject}
                                    onChange={this.handleSubjectChange}
                                />
                            </FormGroup>

                            <FormGroup validationState={!this.state.validation.status ? 'error' : null}>
                                <ControlLabel>Status</ControlLabel>
                                <FormControl
                                    componentClass='select'
                                    id='status'
                                    value={this.state.status}
                                    onChange={this.handleDropDownChange}
                                >
                                    <option value={0}>- Select Status -</option>
                                    {this.props.ticketing.lookupData.ticketStatusList.map((item, index) =>
                                        <option key={`ts-${index}`} value={item.id}>{item.description}</option>
                                    )}
                                </FormControl>
                            </FormGroup>

                            <FormGroup>
                                <ControlLabel>Request Type</ControlLabel>
                                <FormControl
                                    componentClass='select'
                                    id='ticketType'
                                    value={this.state.ticketType}
                                    onChange={this.handleDropDownChange}
                                >
                                    <option value={-1}>- Select Request Type -</option>
                                    {this.props.ticketing.lookupData.ticketTypeList.map((item, index) =>
                                        <option key={`ttype-${index}`} value={item.id}>{item.description}</option>
                                    )}
                                </FormControl>
                            </FormGroup>

                            {(this.state.ticketType == TicketType.MemberCenterRequest || this.state.ticketType == TicketType.ContactPageNonMemberCenter) && (
                                <FormGroup>
                                    <ControlLabel>{this.state.ticketType == TicketType.MemberCenterRequest ? 'Member Center' : 'Non-member Center'}</ControlLabel>
                                    <FormControl
                                        componentClass='select'
                                        id='center'
                                        value={this.state.center}
                                        onChange={this.handleDropDownChange}
                                    >
                                        <option value={0}>- Select Center -</option>
                                        {centerList.map((item, index) =>
                                            <option key={`ctr-${index}`} value={item.id}>{item.alias}</option>
                                        )}
                                    </FormControl>
                                </FormGroup>
                            )}

                            <FormGroup>
                                <ControlLabel>Tier Level</ControlLabel>
                                <FormControl
                                    componentClass='select'
                                    id='tier'
                                    value={this.state.tier}
                                    onChange={this.handleDropDownChange}
                                >
                                    <option value={0}>- Select Tier Level -</option>
                                    {this.props.ticketing.lookupData.ticketTierList.map((item, index) =>
                                        <option key={`ttier-${index}`} value={item.id}>{item.description}</option>
                                    )}
                                </FormControl>
                            </FormGroup>

                            <FormGroup validationState={!this.state.validation.urgency ? 'error' : null}>
                                <ControlLabel>Urgency</ControlLabel>
                                <FormControl
                                    componentClass='select'
                                    id='urgency'
                                    value={this.state.urgency}
                                    onChange={this.handleDropDownChange}
                                >
                                    <option value={-1}>- Select Urgency -</option>
                                    {this.props.ticketing.lookupData.ticketUrgencyList.map((item) =>
                                        <option value={item.id}>{item.description}</option>
                                    )}
                                </FormControl>
                            </FormGroup>

                            <FormGroup>
                                <ControlLabel>Group</ControlLabel>
                                <FormControl
                                    componentClass='select'
                                    id='group'
                                    value={this.state.group}
                                    onChange={this.handleDropDownChange}
                                >
                                    <option value={0}>- Select Group -</option>
                                    {this.props.ticketing.lookupData.ticketGroupList.map((item, index) =>
                                        <option key={`tgrp-${index}`} value={item.id}>{item.name}</option>
                                    )}
                                </FormControl>
                            </FormGroup>

                            <FormGroup>
                                <ControlLabel>Agent</ControlLabel>
                                <FormControl
                                    componentClass='select'
                                    id='assignedTo'
                                    value={this.state.assignedTo}
                                    onChange={this.handleDropDownChange}
                                >
                                    <option value={0}>- Select -</option>
                                    {this.props.ticketing.lookupData.userList.map((item, index) =>
                                        <option key={`user-${index}`} value={item.id}>{item.firstName + ' ' + item.lastName}</option>
                                    )}
                                </FormControl>
                            </FormGroup>

                            <FormGroup validationState={!this.state.validation.description ? 'error' : null}>
                                <ControlLabel>Description</ControlLabel>
                                <JoditEditor
                                    value={this.state.description}
                                    config={config}
                                    onChange={this.handleDescriptionChange}
                                    onBlur={() => null}
                                />

                                {/* <JoditEditor
                                    // ref={editor}
                                    value={this.state.description}
                                    config={config}
                                    // tabIndex={1} // tabIndex of textarea
                                    onBlur={newContent => this.handleDescriptionChange(newContent)} // preferred to use only this option to update the content for performance reasons
                                    onChange={newContent => { }}
                                /> */}

                                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginTop: 5 }}>
                                    <div>
                                        <Button bsSize='xs' title='Canned Responses' onClick={this.handleShowCannedResponses}><Glyphicon glyph='comment' /></Button>
                                    </div>
                                    <div>
                                        <MyUploader filesChanged={this.handleFilesChanged} />
                                    </div>
                                </div>
                            </FormGroup>

                            <FormGroup>
                                <ControlLabel>Tags</ControlLabel>
                                <CreatableSelect
                                    defaultValue={[]}
                                    value={this.state.tags}
                                    isMulti
                                    name='tags'
                                    options={tagSuggestions}
                                    components={{ DropdownIndicator }}
                                    styles={{
                                        indicatorSeparator: defaultStyles => ({ ...defaultStyles }),
                                        dropdownIndicator: defaultStyles => ({
                                            ...defaultStyles,
                                            color: 'black'
                                        }),
                                        multiValueLabel: (styles, { data }) => ({
                                            ...styles,
                                            backgroundColor: 'pink'
                                        }),
                                        multiValueRemove: (styles, { data }) => ({
                                            ...styles,
                                            backgroundColor: 'pink'
                                        }),
                                    }}
                                    onChange={this.handleTagsChange}
                                />
                            </FormGroup>

                            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                                <div>
                                    <Checkbox checked={this.state.createAnother} onChange={this.handleCreateAnotherChange}>Create another</Checkbox>
                                </div>
                                <div>
                                    <Button bsStyle='primary' bsSize='large' style={{ marginRight: 5 }} onClick={this.handleSave}>Create</Button>
                                    <Button bsStyle='link' onClick={this.handleCancel}>Cancel &amp; return to the list</Button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <Drawer
                    width='20vw'
                    // handler={false}
                    placement='right'
                    getContainer={this.getContainer}
                    open={this.state.showCannedResponses}
                >
                    <CannedResponses
                        cannedResponses={cannedResponses}
                        onApply={this.handleApplyCannedResponse}
                        onClose={this.handleCloseCannedResponses}
                    />
                </Drawer>
            </>
        )
    };
}

const mapStateToProps = (state: IApplicationState): IStateProps => {
    return {
        app: state.app,
        ticketing: state.ticketing,
        centers: state.centers
    };
}

const mapDispatchToProps = (dispatch: Dispatch<any>): IDispatchProps => {
    return {
        showLoading: (message) => {
            return dispatch<any>(AppActionCreators.showLoadingAsync(message));
        },
        hideLoading: () => {
            return dispatch<any>(AppActionCreators.hideLoading());
        },
        getLookupData: () => {
            return dispatch<any>(TicketingActionCreators.getLookupData());
        },
        getContacts: (search) => {
            return dispatch<any>(ContactActionCreators.getContacts(search));
        },
        getCannedResponses: () => {
            return dispatch(TicketingActionCreators.getCannedResponses());
        },
        saveTicket: (newTicket) => {
            return dispatch<any>(TicketingActionCreators.saveTicket(newTicket));
        }
    };
}

export default connect<IStateProps, IDispatchProps, IProps>(
    mapStateToProps,
    mapDispatchToProps)(NewTicket);